import { gql, useMutation } from '@apollo/client';

function useLogError() {
  const [logError, { loading, error, data }] = useMutation(LOG_ERROR);

  return [logError, { loading, error, data }];
}

export default useLogError;

const LOG_ERROR = gql`
  mutation logError($error: String!) {
    logError(error: $error) {
      success
    }
  }
`;
